import React, { useCallback, useEffect, useState } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { LoadingSpinner } from '@tadagram/ui';
import { useAuthBridge } from './hooks/useAuthBridge';
import { useIframeNavigationSync } from './hooks/useIframeNavigationSync';
import MainLayout from './components/layout/MainLayout';
import Browse from './pages/Browse';
import Sell from './pages/Sell';
import MyListings from './pages/MyListings';
import Trades from './pages/Trades';
import Withdrawals from './pages/Withdrawals';
import { authService } from './services/auth';

function IframeNavSync() {
  useIframeNavigationSync();
  return null;
}

const App: React.FC = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const handleAuthSuccess = useCallback(() => {
    setIsAuthenticated(true);
  }, []);

  const handleLoadingDone = useCallback(() => {
    setIsLoading(false);
  }, []);

  useAuthBridge({
    onAuthSuccess: handleAuthSuccess,
    onLoadingDone: handleLoadingDone,
  });

  useEffect(() => {
    if (import.meta.env.DEV && import.meta.env.VITE_DEV_TOKEN) {
      authService.setAuthToken(
        import.meta.env.VITE_DEV_TOKEN as string,
        import.meta.env.VITE_DEV_BUSINESS_ID as string | undefined,
      );
      setIsAuthenticated(true);
      setIsLoading(false);
    }
  }, []);

  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          backgroundColor: 'var(--color-bg)',
        }}
      >
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  return (
    <BrowserRouter>
      <IframeNavSync />
      <Routes>
        <Route path="/" element={<Navigate to="/business-marketplace" replace />} />
        <Route
          path="/business-marketplace/*"
          element={
            isAuthenticated ? (
              <MainLayout>
                <Routes>
                  <Route index element={<Browse />} />
                  <Route path="sell" element={<Sell />} />
                  <Route path="my-listings" element={<MyListings />} />
                  <Route path="trades" element={<Trades />} />
                  <Route path="withdrawals" element={<Withdrawals />} />
                  <Route path="*" element={<Navigate to="/business-marketplace" replace />} />
                </Routes>
              </MainLayout>
            ) : (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: '100vh',
                  flexDirection: 'column',
                  gap: '12px',
                  color: 'var(--color-text-secondary)',
                }}
              >
                <h2 style={{ color: 'var(--color-text-main)' }}>Yêu cầu đăng nhập từ BizTada</h2>
                <p>Mở app từ BizTada shell để nhận token xác thực tự động.</p>
              </div>
            )
          }
        />
        <Route path="*" element={<Navigate to="/business-marketplace" replace />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
